"use strict";
import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_PROTOCOL_OPTIONS
} from "features/transactions/swap/utils/protocols";
import { DEFAULT_ROUTE_SOURCES } from "features/transactions/swap/utils/routingProvider";
export var TransactionSettingKey = /* @__PURE__ */ ((TransactionSettingKey2) => {
  TransactionSettingKey2["Swap"] = "swap";
  TransactionSettingKey2["LP"] = "lp";
  return TransactionSettingKey2;
})(TransactionSettingKey || {});
export const initialTransactionSettingsState = {
  selectedProtocols: DEFAULT_PROTOCOL_OPTIONS,
  isV4HookPoolsEnabled: true,
  slippageWarningModalSeen: false,
  routeSources: DEFAULT_ROUTE_SOURCES
};
const slice = createSlice({
  name: "transactionSettings",
  initialState: {
    ["swap" /* Swap */]: initialTransactionSettingsState,
    ["lp" /* LP */]: initialTransactionSettingsState
  },
  reducers: {
    setTransactionSettings: (state, { payload }) => {
      if (!payload.settingKey) {
        throw new Error("TransactionSettingsState settingKey not provided");
      }
      const { settingKey, ...settings } = payload;
      Object.assign(state[settingKey], settings);
    }
  }
});
export const { setTransactionSettings } = slice.actions;
export const transactionSettingsReducer = slice.reducer;
